/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
/**
 * @ignore
 * This module returns a function that returns a mixin object with helper functions to start listen on layers' events.
 * This module has a soft dependency to the traffic and trafficFlow modules.
 */
/* jshint nomen:false */
define([], function() {
    'use strict';

    /**
     * @ignore
     * @param {String} baseName
     * @return {String} Name of the property in the layer instance
     */
    function getFlagName(baseName) {
        return '_' + baseName + 'Added';
    }

    /**
     * @ignore
     * @param {L.Layer} source Layer instance that could be added to or removed from the map if is necessary
     * @param {String} flagName
     * @return {String} Value of the property in the layer instance
     */
    function getFlag(source, flagName) {
        return source[getFlagName(flagName)];
    }

    /**
     * @ignore
     * @param {L.Layer} source Layer instance
     * @param {String} baseLayerName
     * @return {Boolean}
     */
    function shouldAddLayer(source, baseLayerName) {
        var mapUseBaseLayer, mapUseTraffic, mapUseTrafficFlow, mapUseVectorTrafficFlow;
        mapUseBaseLayer = Boolean(getFlag(source, baseLayerName));
        mapUseTraffic = Boolean(getFlag(source, 'traffic'));
        mapUseTrafficFlow = Boolean(getFlag(source, 'trafficFlow'));
        mapUseVectorTrafficFlow = Boolean(getFlag(source, 'vectorTrafficFlow'));
        return mapUseBaseLayer && (mapUseTraffic || mapUseTrafficFlow || mapUseVectorTrafficFlow);
    }

    /**
     * @ignore
     * @param {L.Layer} source Layer instance
     * @param {String} baseLayerName
     * @return {Boolean}
     */
    function shouldRemoveLayer(source, baseLayerName) {
        return !shouldAddLayer(source, baseLayerName);
    }

    /**
     * @ignore
     * @param {L.Layer} source Layer instance that could be added to the map if is necessary
     * @param {L.Map} map
     * @param {String} baseLayerName
     */
    function addIfNecessary(source, map, baseLayerName) {
        if (source._attached) {
            return;
        }
        if (shouldAddLayer(source, baseLayerName)) {
            map.addLayer(source);
            source._attached = true;
        }
    }

    /**
     * @ignore
     * @param {L.Layer} source Layer instance that could be removed from the map if is necessary
     * @param {L.Map} map
     * @param {String} baseLayerName
     */
    function removeIfNecessary(source, map, baseLayerName) {
        if (!source._attached) {
            return;
        }
        if (shouldRemoveLayer(source, baseLayerName)) {
            map.removeLayer(source);
            source._attached = false;
        }
    }

    return function(baseLayerName) {
        return {
            /**
             * @ignore
             * Install listeners to add or remove the current Layer instance (of the
             * class that use this mixin functions) if specific Layer types are added to the map.
             * @param {L.Map} map
             */
            registerEventHandlers: function(map) {
                var that = this;

                map.on('layeradd', function(event) {
                    var layerName = event.layer.name;
                    if (!layerName) {
                        return;
                    }
                    that[getFlagName(layerName)] = true;
                    addIfNecessary(that, map, baseLayerName);
                });
                map.on('layerremove', function(event) {
                    var layerName = event.layer.name;
                    if (!layerName) {
                        return;
                    }
                    that[getFlagName(layerName)] = false;
                    removeIfNecessary(that, map, baseLayerName);
                });
            }
        };
    };
});



// WEBPACK FOOTER //
// ./display/layers/labelsLayerMixinFactory.js